import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { config } from '../../../../config/config';
import { ImageService } from '../../../services/image.service';
import { bindFunctionsToThis } from '../../extensions';
import { BaseComponent } from '../base.component';
import AuthResponse = facebook.AuthResponse;
import StatusResponse = facebook.StatusResponse;
import { GlobalEventEmitter } from "../../services/global.event.emitter";

@Component({
    selector: 'ig-fb-login-btn',
    templateUrl: './facebook.login.button.component.html',
    styleUrls: ['./facebook.login.button.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FacebookLoginButtonComponent {
    public fbLogo = config.fbLogo;
    public static isUserLoggedWithFacebook: boolean;
    public static userAccessToken: string;
    public static authResponse: StatusResponse;
    public static profilePicture: string;
    public static isSmallPC: boolean;
    public static isMobile: boolean;
    public static isExSmallMobile: boolean;
    @Input() public customize = false;
    @Input() public text: string;
    @Input() public isQuadrate = false;
    @Input() public isSmallest = false;
    @Output() public onLoginStatusChanged = new EventEmitter<boolean>();
    @ViewChild('profileImg') public profileImg: ElementRef;

    public get isUserLoggedWithFacebook() {
        return FacebookLoginButtonComponent.isUserLoggedWithFacebook;
    }
    public get profilePicture() {
        return FacebookLoginButtonComponent.profilePicture;
    }
    public get isSmallPC() {
        return FacebookLoginButtonComponent.isSmallPC;
    }
    public get isMobile() {
        return FacebookLoginButtonComponent.isMobile;
    }
    public get isExSmallMobile() {
        return FacebookLoginButtonComponent.isExSmallMobile;
    }

    constructor(private imageService: ImageService) {
        bindFunctionsToThis(this);
        this.fbLogo = this.imageService.imageSourceUrl(this.fbLogo);
        this.syncFacebookStatus();
        FacebookLoginButtonComponent.isExSmallMobile = window.innerWidth < config.exSmallphoneSizeWidth;
        FacebookLoginButtonComponent.isMobile = window.innerWidth < config.phoneSizeWidth && !FacebookLoginButtonComponent.isExSmallMobile;
        FacebookLoginButtonComponent.isSmallPC = window.innerWidth < config.smallPCSizeWidth && !FacebookLoginButtonComponent.isMobile;
    }

    public login() {
        FB.login((response: StatusResponse ) => {
            if (!response || !response.authResponse) {
                return;
            }

            this.syncFacebookStatus();
        }, {scope: config.facebook.graphApi.scope});
    }

    public logout() {
        FB.logout(() => {
            this.syncFacebookStatus();
        });
    }

    private syncFacebookStatus() {
        try {
            FB.getLoginStatus(response => {
                if (response.status === 'connected') {
                    FacebookLoginButtonComponent.isUserLoggedWithFacebook = true;
                    FacebookLoginButtonComponent.authResponse = response;
                    FacebookLoginButtonComponent.userAccessToken = response.authResponse.accessToken;
                    FacebookLoginButtonComponent.profilePicture = config.facebook.graphApi.profilePicture
                        .replace('${userId}', response.authResponse.userID);
                    setTimeout(() => {
                        if (this.profileImg) {
                            this.profileImg.nativeElement.style.display = 'block';
                        }
                        this.onLoginStatusChanged.emit(true);

                        // for some components (such as the PlaceDetailsModal) which cannot get the event, it uses this global event emitter to emit the login status
                        GlobalEventEmitter.emit('onFBLoginStatusChanged');
                        console.log('emit onFBLoginStatusChanged true');
                    });
                } else {
                    FacebookLoginButtonComponent.isUserLoggedWithFacebook = false;
                    FacebookLoginButtonComponent.authResponse = null;
                    FacebookLoginButtonComponent.userAccessToken = null;
                    FacebookLoginButtonComponent.profilePicture = null;
                    setTimeout(() => {
                        if (this.profileImg) {
                            this.profileImg.nativeElement.style.display = 'none';
                        }
                        this.onLoginStatusChanged.emit(false);

                        // for some components (such as the PlaceDetailsModal) which cannot get the event, it uses this global event emitter to emit the login status
                        GlobalEventEmitter.emit('onFBLoginStatusChanged');
                        console.log('emit onFBLoginStatusChanged false');
                    });
                }
            });
        } catch (e) {
            console.warn(e);
        }
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/facebook.login.button/facebook.login.button.component.ts